"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Chip_1 = tslib_1.__importDefault(require("@material-ui/core/Chip"));
var Chip_style_1 = require("./Chip.style");
var Cancel_1 = tslib_1.__importDefault(require("@material-ui/icons/Cancel"));
var Tooltip_1 = tslib_1.__importDefault(require("@material-ui/core/Tooltip"));
var Chip = function (_a) {
    var name = _a.name, label = _a.label, disabled = _a.disabled, onDelete = _a.onDelete;
    var classes = (0, Chip_style_1.useChipStyles)();
    return (react_1.default.createElement(Tooltip_1.default, { title: label, enterDelay: 1000, leaveDelay: 250 },
        react_1.default.createElement(Chip_1.default, { classes: {
                root: classes.root,
                disabled: classes.disabled,
            }, "data-signa": "chip-".concat(name), label: label, disabled: disabled, onDelete: onDelete, deleteIcon: react_1.default.createElement(Cancel_1.default, { "data-signa": "chip-".concat(name, "-delete") }) })));
};
exports.Chip = Chip;
